import axios, { type AxiosInstance } from 'axios';
import { config } from '@/config';

/**
 * Единственный HTTP-клиент приложения. Все запросы идут на BFF по относительному
 * /api (dev – Vite proxy, prod – nginx). withCredentials, чтобы cookie-сессия
 * BFF ходила вместе с запросами.
 */
export const apiClient: AxiosInstance = axios.create({
  baseURL: config.apiBase,
  withCredentials: true,
  timeout: 15_000,
  headers: { Accept: 'application/json' },
});
